
import { eventStore, scheduleStore } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';
import NoData from '../training/NoData.vue';

@Component({
  components: {
    NoData,
  },
})
export default class Daily extends Vue {
  @Prop({ default: '' }) eventsScheduling;
  @Prop({ default: '' }) pageDay;
  @Prop({ default: '' }) openEvent;
  @Prop({ default: '' }) eventHour;
  @Prop({ default: '' }) itemPage;
  filterOption: string = 'Todos';

  transformEventStoreEvent(event) {
    return {
      name: event.name,
      avatar: event.avatar,
      id: event.id,
      start: new Date(event.start).getTime(),
      end: new Date(event.end).getTime(),
      departure_id: event.departure_id,
      source: 'eventStore',
    };
  }

  transformScheduleEvent(event) {
    return {
      name: event.name,
      id: event.id,
      avatar: null,
      start: new Date(event.date).getTime(),
      end: new Date(event.date).getTime(),
      departure_id: event.departure_id,
      link: event.link,
      createdBy: event.user?.full_name || 'Desconhecido',
      source: 'scheduleStore',
    };
  }

  // Getter para combinar eventos
  get eventss() {
    const eventsFromStore = eventStore.events.map((event) => ({
      ...this.transformEventStoreEvent(event),
      source: 'eventStore',
    }));

    const schedulesFromStore = scheduleStore.schedules.map((event) => ({
      ...this.transformScheduleEvent(event),
      source: 'scheduleStore',
    }));

    return [...eventsFromStore, ...schedulesFromStore];
  }

  get eventsToday() {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    // Filtrar eventos com base no filtro ativo
    let filteredEvents = this.eventss.filter((event) => {
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);
      const isToday =
        eventStart >= todayStart && eventStart <= todayEnd && eventEnd >= todayStart && eventEnd <= todayEnd;

      if (this.filterOption === 'Todos') {
        return isToday;
      } else if (this.filterOption === 'Treinamento') {
        return isToday && event.source === 'eventStore';
      } else if (this.filterOption === 'Agenda') {
        return isToday && event.source === 'scheduleStore';
      }
      return false;
    });

    // Priorizar eventos da agenda no topo quando o filtro for "Todos"
    if (this.filterOption === 'Todos') {
      filteredEvents = filteredEvents.sort((a, b) => {
        if (a.source === 'scheduleStore' && b.source !== 'scheduleStore') {
          return -1;
        }
        if (b.source === 'scheduleStore' && a.source !== 'scheduleStore') {
          return 1;
        }
        return 0;
      });
    }

    return filteredEvents;
  }

  handleEventClick(event) {
    if (event.source === 'eventStore') {
      const originalEvent = eventStore.events.find((e) => e.id === event.id);
      this.$emit('eventStoreClicked', { ...originalEvent, source: 'eventStore' });
    } else if (event.source === 'scheduleStore') {
      const originalSchedule = scheduleStore.schedules.find((e) => e.id === event.id);
      this.$emit('scheduleStoreClicked', {
        ...originalSchedule,
        source: 'scheduleStore',
      });
    }
  }

  getEventColor(event) {
    if (event.source === 'eventStore') {
      return 'var(--v-primary)'; // Cor padrão para eventStore
    } else {
      const departmentColors = {
        1: 'var(--v-Marketing)',
        2: 'var(--v-Comercial)',
        3: 'var(--v-Recursos-Humanos)',
        4: 'var(--v-Administrativo)',
        5: 'var(--v-Pedagogico)',
        6: 'var(--v-CAF)',
        7: 'var(--v-Tecnologia)',
        8: 'var(--v-Expansao)',
        9: 'var(--v-Retencao)',
        10: 'var(--v-Contabilidade)',
        11: 'var(--v-Financeiro)',
        12: 'var(--v-Ouvidoria)',
        13: 'var(--v-Implantaçao)',
        14: 'var(--v-Padronizacao)',
        43: 'var(--v-Conversao)',
        44: 'var(--v-Juridico)',
        45: 'var(--v-Auditoria)',
        46: 'var(--v-Imprensa)',
        47: 'var(--v-Pedido-de-Livros)',
        48: 'var(--v-Edicao)',
        49: 'var(--v-Compras)',
        50: 'var(--v-Reservas)',
        51: 'var(--v-Fiscal)',
        52: 'var(--v-Drive)',
        53: 'var(--v-Digital)',
        54: 'var(--v-Relacionamento)',
        55: 'var(--v-Gestao-Administrativa)',
        56: 'var(--v-Assessoria-reg)',
        57: 'var(--v-Expedicao)',
      };

      return departmentColors[event.departure_id] || 'var(--v-grey800)';
    }
  }
}
